import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  infoField: {
    position: 'relative',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2, 2, 1.5),
  },
  infoFieldLabel: {
    position: 'absolute',
    top: -10,
    left: 12,
    padding: theme.spacing(0, 0.5),
    backgroundColor: theme.palette.background.paper,
  },
  templatePreviewScroll: {
    maxHeight: 600,
    overflowY: 'auto',
  },
}))

export default useStyles
